module.exports = __webpack_public_path__ + "static/media/Cardboard Robot.bd776ee7.jpg";